import { turnWordIntoLink } from '../changeEditorLinkFns';

export const onKeyCommand = ({ command, editorState, onChange }) => {
  if (command === 'split-block') {
    return turnWordIntoLink({
      editorState,
      endChar: '\n',
      onChange,
    });
  }
  return 'not-handled';
};
